import RichTextArea from "./RichTextArea";

interface AgendaInputProps {
  value: string;
  onChange: (value: string) => void;
}

const AgendaInput = ({ value, onChange }: AgendaInputProps) => {
  const handleChange = (newValue: string) => {
    // Remove "PROGRAMME" if it appears at the end of the text
    const cleanedValue = newValue.replace(/\s*PROGRAMME\s*$/i, '');
    onChange(cleanedValue);
  };

  return (
    <RichTextArea
      id="agendaText"
      value={value || ''}
      onChange={handleChange}
      label="Agenda"
      placeholder="Enter agenda items"
      helpText="You can use HTML tags for:
        - Bold text: <b>bold</b>
        - Italic text: <i>italic</i>
        - Links: <a href='url'>link text</a>"
    />
  );
};

export default AgendaInput;